import { useDispatch } from "react-redux";
import CustomPage from "../../../../components/CustomPage";
import { useEffect, useState } from "react";
import moment from "moment";
import http from "../../../../http";
import { DATE_FOR_API_FORMAT, DATE_TIME_FORMAT } from "../../../../config/const";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { apiUrl } from "../../../../config/settings";
import { setShowLoading } from "../../../../store/sysSlice";
import CustomDataGrid from "components/customDataGrid";
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from "@mui/material";
import { ExpandMore, VerticalAlignTop } from "@mui/icons-material";
import { currencyFormat, sum } from "config/functions";

const YearlyServiceCallReports = () => {
  const dispatch = useDispatch();
  const { bt } = useBizTypeTranslation();
  const [list, setList] = useState([]);

  useEffect(() => {
    getData()
  }, []);

  const getData = async () => {
    dispatch(setShowLoading(true));
    http.get(`${apiUrl}/reports/callYearlyServiceSummary`)
      .then((res) => {
        setList(res?.data?.data);
        dispatch(setShowLoading(false));
      });
  };


  return (
    <CustomPage >
      {list?.map((months, index) => {
        const sumExpenses = sum(months, "expenses");
        const sumIncome = sum(months, "income");
        const profit = sumIncome - sumExpenses;
        return (
          <Accordion>
            <AccordionSummary
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Stack direction='row' spacing={2} alignItems="center" justifyContent="space-between" width="100%">
                <Typography fontWeight='bold' >
                  {`${index + 1}/${moment().format("YYYY")}`}
                </Typography>

                <Typography
                  color={profit === 0 ? 'black' : profit <= 0 ? "red" : "green"}
                  fontWeight='bold'
                >
                  {`${bt("PROFIT_OR_LOSS")}: ${currencyFormat(Math.abs(sumIncome - sumExpenses))}`}
                </Typography>
              </Stack>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: 0 }}>
              <CustomDataGrid
                hideFooter
                autoHeight
                columns={[
                  {
                    field: "clienCompany",
                    headerName: bt("COMPANY"),
                    width: 150,
                    filterable: false,
                  },
                  {
                    field: "clientId",
                    headerName: bt("CLIENT_GUID"),
                    width: 150,
                    filterable: false,
                  },
                  {
                    field: "income",
                    headerName: bt("INCOME"),
                    width: 150,
                    filterable: false,
                    renderCell: (value) => {
                      return (
                        <Stack height='100%' justifyContent='center'>
                          <Typography color={"green"}>
                            {currencyFormat(Math.abs(value.value))}
                          </Typography>
                        </Stack>
                      );
                    }
                  },
                  {
                    field: "expenses",
                    headerName: bt("EXPENSES"),
                    width: 150,
                    filterable: false,
                    renderCell: (value) => {
                      return (
                        <Stack height='100%' justifyContent='center'>
                          <Typography color={"red"}>
                            {currencyFormat(Math.abs(value.value))}
                          </Typography>
                        </Stack>
                      );
                    }
                  },
                  {
                    field: "profit",
                    headerName: bt("PROFIT_OR_LOSS"),
                    width: 150,
                    filterable: false,
                    renderCell: (value) => {
                      return (
                        <Stack height='100%' justifyContent='center'>
                          <Typography color={value.value === 0 ? '' : value.value <= 0 ? "red" : "green"}>
                            {currencyFormat(Math.abs(value.value))}
                          </Typography>
                        </Stack>
                      );
                    }
                  },
                ]}
                list={months?.filter(call => call?.expenses > 0 || call?.income > 0)?.map((call, index) => {
                  return {
                    ...call,
                    id: index,
                    clienCompany: call?.clienCompany,
                    clientId: call?.clientId,
                    expenses: call?.expenses,
                    income: call?.income,
                    profit: call?.income - call?.expenses,
                  };
                })}
              />
            </AccordionDetails>
          </Accordion>
        )
      })}

    </CustomPage>
  );
};
export default YearlyServiceCallReports;
